import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPerfAlertDefAdvancedSearch extends Layout {
    id10: Textbox;
    id11: Textbox;
    id12: Textbox;
    id23: Textbox;
    id24: Textbox;
    id25: Textbox;
    id26: Textbox;
    id27: Textbox;
    id28: Textbox;
    id29: Panel;
    id2: Panel;
    id32: Panel;
    id33: Checkbox;
    id34: Textbox;
    id35: Textbox;
    id36: Textbox;
    id37: Textbox;
    id38: Textbox;
    id39: Textbox;
    id3: Textbox;
    id40: Textbox;
    id41: Textbox;
    id42: Textbox;
    id43: Textbox;
    id4: Textbox;
    id5: Panel;
    id8: Panel;
    id9: Textbox;
    labelAlertinformation: Label;
    labelEmailnotification: Label;
    panelValues: Panel;
    sourceperf_alert_def: DataSource;
    textboxImportantValue: Textbox;
    textboxUrgentValue: Textbox;
    textboxWarningValue: Textbox;
}
